<template>
    <div>
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0 24px;">
            <h2 class="pb-2">{{ this.parentObject.pageTitle }}</h2>
        </div>
        <v-container>
            <v-form>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4">
                        <v-autocomplete
                            outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text" 
                            :rules="[rules.required]" ref="pmassessmentrecorddesc"
                            v-model="formData.pmassessmentrecorddesc" dense :items="pmAssessmentRecordList"
                            @input="updateValue" @change="changeAssessmentDetails(formData.pmassessmentrecorddesc)"
                            item-value="value" item-text="text"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="formData.pmassessmentrecordcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.periodfromdate')" type="date" ref="startdate"
                            :rules="[rules.required]" v-model="formData.startdate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.perioduntildate')" type="date" ref="enddate"
                            :rules="[rules.required]" v-model="formData.enddate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>    
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">

                    </v-col>
                    <div v-if="isSelected">
                        <v-col cols="1" sm="1" class="pb-n4 mt-n8">
                            <v-btn icon color="orange" @click="generateGraph" class="mr-5">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </v-col>
                    </div>
                </v-row>
                <v-row v-if="isClickSelected">
                    <v-col v-for="(chart, companyName) in companyCharts" :key="companyName" cols="5" sm="5" style="padding-right: 10px">
                        <div>
                            <apexchart :options="chart.chartOptions" :series="chart.series" type="line" height="350"></apexchart>
                        </div>
                        <div>
                            <v-data-table
                                :headers="tableHeaders"
                                :items="groupedFinalRankSummary[companyName].data" 
                                class="elevation-1"
                                hide-default-footer
                            >
                            
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.rank }}</td>
                                        <td>{{ item.totalcount }}</td>
                                        <td>{{ item.distribution }}%</td> 
                                    </tr>
                                </template>
                            </v-data-table>
                            <v-data-table
                                :headers="secondTableHeaders"
                                :items="groupedFinalRankSummary[companyName].secondTableData"
                                class="elevation-1 mt-4"
                                hide-default-footer
                            >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.rank }}</td>
                                    <td>{{ item.target_distribution }}%</td>
                                    <td>{{ item.idealCount }}</td>
                                    <td :class="{ 'red--text': item.delta < 0, 'green--text': item.delta > 0 }">
                                        {{ item.delta }}
                                    </td>
                                </tr>
                            </template>
                            </v-data-table>
                            <v-btn 
                                color="primary" 
                                class="mt-4"
                                @click="goToNextPage(companyName)"
                            >
                                {{$t('pmmoderation.viewdetails')}}
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import VueApexCharts from "vue-apexcharts";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'apexchart': VueApexCharts
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: null,
                pmassessmentrecordcode: null,
                pmassessmentrecorddesc: null,
                startdate: null,
                enddate: null,
                ratingtype: null,
                ratingid: null,
                userid: this.$store.getters.userId,
            },

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
            isSelected: false,
            isClickSelected: false,
            pmAssessmentRecordList: [],
            pmAssessmentRecordFull: [],
            finalRankSummary: [],
            groupedFinalRankSummary: [], // Grouped data by company, first table
            companyCharts: {},

            // tableHeaders: [
            //     { text: "Rank", value: "rank" },
            //     { text: "Total Count", value: "totalcount" },
            //     { text: "Distribution (%)", value: "distribution" }
            // ],

            // secondTableHeaders: [
            //     { text: "Rank", value: "rank" },
            //     { text: "Ideal %", value: "target_distribution" },
            //     { text: "Ideal Count", value: "idealCount" },
            //     { text: "Delta", value: "delta" }
            // ],
            tableHeaders: [],
            secondTableHeaders: []

        };
    },
    created() {
        this.tableHeaders = [
            { text: this.$t('Setuprankmapset.rank'), value: "rank" },
            { text: this.$t('pmassementrecord.totalcount'), value: "totalcount" },
            { text: this.$t('pmassementrecord.distribution'), value: "distribution" }
        ];

        this.secondTableHeaders = [
            { text: this.$t('Setuprankmapset.rank'), value: "rank" },
            { text: this.$t('pmmoderation.ideal_percent'), value: "target_distribution" },
            { text: this.$t('pmmoderation.ideal_count'), value: "idealCount" },
            { text: this.$t('pmmoderation.delta'), value: "delta" }
        ];
    },

    methods: {
        updateValue() {
            this.$emit('input', {
                pmassessmentrecordcode: this.formData.pmassessmentrecordcode,
                pmassessmentrecorddesc: this.formData.pmassessmentrecorddesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                ratingtype: this.formData.ratingtype,
                userid: this.formData.userid,
            });
        },
        
        async loadPerformanceAssessmentRecordHandler() {
            try {
                const res = await this.$store.dispatch("get", { url: "/calculatedPmAsse" });

                if (res.data?.rec) {
                    this.pmAssessmentRecordFull = res.data.rec;
                    this.pmAssessmentRecordList = res.data.rec.map(record => ({
                        text: record.pmassessmentrecorddesc,
                        value: record.id,
                    }));
                } else {
                    throw new Error("Unexpected response format.");
                }
            } catch (err) {
                console.error("Error fetching assessment record:", err);
                this.isErr = true;
                this.errMsg = err.response?.data?.error || "Failed to load data";
            }
        },

        changeAssessmentDetails(id) {
            let item = this.pmAssessmentRecordFull.find((item) => item.id === id);
            this.isSelected = true; //show the orange refresh button
            this.formData.id = item.id;
            this.formData.ratingid = item.ratingid;
            this.formData.ratingtype = item.ratingtype;
            this.formData.pmassessmentrecordcode = item.pmassessmentrecordcode;
            this.formData.startdate = moment(item.startdate).format('YYYY-MM-DD');
            this.formData.enddate = moment(item.enddate).format('YYYY-MM-DD');
        },

        async generateGraph() {
            this.isClickSelected = false;
            this.companyCharts = {}; 
            await this.loadFinalRankSummary();


            Object.keys(this.groupedFinalRankSummary).forEach(companyName => {
                const companyData = this.groupedFinalRankSummary[companyName].data; // Access .data
                
                this.companyCharts[companyName] = {
                    series: [{ 
                        name: this.$t('pmmoderation.headcount'),
                        data: companyData.map(item => item.totalcount) 
                    }],
                    chartOptions: {
                        chart: { type: "line", zoom: { enabled: false } ,toolbar: { show: false }},
                        xaxis: { categories: companyData.map(item => item.rank) },
                        dataLabels: { enabled: false },
                        stroke: { curve: 'straight' },
                        title: { text: companyName, align: 'left', style: { color: '#3d4be3' } },
                        grid: { row: { colors: ['#f3f3f3', 'transparent'], opacity: 0.5 } },
                        markers: { size: 5 },
                    },
                };
            });

            this.isClickSelected = true;
        },

        async loadFinalRankSummary() {
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/finalRankSummaryDiffCompany/${this.formData.id}/${this.formData.ratingid}`,
                });

                if (res.data?.summary) {
                    this.finalRankSummary = res.data.summary;

                    // Group by company
                    this.groupedFinalRankSummary = this.groupByCompany(res.data.summary);

                } else {
                    this.finalRankSummary = [];
                    console.warn("⚠️ No summary data received.");
                }
            } catch (err) {
                console.error("❌ Error fetching final rank summary:", err);
                this.finalRankSummary = [];
            }
        },

        // Helper function to group data by company,using isLast, should be optimize to median(bell curve)
        // groupByCompany(data) {
        //     const grouped = {};
            
        //     data.forEach(item => {
        //         // Initialize company group if it doesn't exist
        //         if (!grouped[item.companyname]) {
        //             grouped[item.companyname] = {
        //                 data: [],          // Stores individual rank entries
        //                 totalHeadCount: 0, // Stores the sum of all employees in the company
        //                 secondTableData: [],  // <-- New array for second table
        //                 tempIdealSum: 0  // <<-- Reset for each new company
        //             };
        //         }
                
        //         // Add the current item to the company's data
        //         grouped[item.companyname].data.push(item);
        //         // Accumulate the total head count (sum of all ranks)
        //         grouped[item.companyname].totalHeadCount += item.totalcount;
        //         });

        //     // Process each company separately
        //     Object.keys(grouped).forEach(companyName => {
        //         const company = grouped[companyName];
        //         company.tempIdealSum = 0;  // <<-- Explicit reset (redundant but safe)
                
        //         company.data.forEach(item => {
        //             let idealCount;
                    
        //             if (item.isLast) {//to normalize the result
        //                 idealCount = company.totalHeadCount - company.tempIdealSum;
        //             } else {
        //                 idealCount = Math.round((item.target_distribution / 100) * company.totalHeadCount);
        //                 company.tempIdealSum += idealCount;
        //             }
        //             //because normalization at is last  not that beautiful , data should be bell curve,
        //             //so we should normalize it a median
        //             //my idea is using isMedian, when we reach isMedian then we hold the rank first, calculate the rest
        //             //and then ,after the looping , we use total headcount minus tempIdealSum, so we normalize it at the median
        //             //and then pushing into the array, but after pushing it , we sort the array using uptoscore, so we sort back the median in the right place
        //             //any other idea how to do it  
                    
        //             company.secondTableData.push({
        //                 rank: item.rank,
        //                 target_distribution: item.target_distribution,
        //                 idealCount: idealCount,
        //                 delta: item.totalcount - idealCount
        //             });
        //         });
        //     });

 
        //     return grouped;
        // },

        //Helper function to group data by company, using isMedian, should work fine
        groupByCompany(data) {
            const grouped = {};
            
            // First pass: Group data and calculate totals
            data.forEach(item => {
                if (!grouped[item.companyname]) {
                    grouped[item.companyname] = {
                        data: [],
                        totalHeadCount: 0,
                        secondTableData: [],
                        tempIdealSum: 0,
                        medianData: null  // Store median item separately
                    };
                }
                grouped[item.companyname].data.push(item);
                grouped[item.companyname].totalHeadCount += item.totalcount;
            });

            // Second pass: Calculate ideal counts with median normalization
            Object.keys(grouped).forEach(companyName => {
                const company = grouped[companyName];
                company.tempIdealSum = 0;
                
                // 1. Sort by uptoscore to maintain correct order
                const sortedRanks = [...company.data].sort((a, b) => a.uptoscore - b.uptoscore);
                
                // 2. First pass: Process non-median ranks
                sortedRanks.forEach(item => {
                    if (!item.isMedian) {
                        const idealCount = Math.round((item.target_distribution / 100) * company.totalHeadCount);
                        company.tempIdealSum += idealCount;
                        company.secondTableData.push({
                            ...item,
                            idealCount,
                            delta: item.totalcount - idealCount
                        });
                    } else {
                        // Store median item for later processing
                        company.medianData = item;
                    }
                });

                // 3. Process median rank (if exists)
                if (company.medianData) {
                    const medianIdealCount = company.totalHeadCount - company.tempIdealSum;
                    company.secondTableData.push({
                        ...company.medianData,
                        idealCount: medianIdealCount,
                        delta: company.medianData.totalcount - medianIdealCount
                    });
                }

                // 4. Re-sort by uptoscore to ensure median is in correct position
                company.secondTableData.sort((a, b) => a.uptoscore - b.uptoscore);
            });

            return grouped;
        },

        goToNextPage(companyName) {
            this.$router.push({ name: 'performancemoderationrecorddetail', params: { id:this.formData.id, company: companyName } });
        },
    },

    async mounted() {
        await this.loadPerformanceAssessmentRecordHandler();
    }
};
</script>